export default __webpack_public_path__ + "static/media/NLR-7.cb59968b.webp";